import { render } from "./ScienceResearch.vue?vue&type=template&id=2fbcf8d5"
import script from "./ScienceResearch.vue?vue&type=script&lang=js"
export * from "./ScienceResearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__